import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import metadata from '../data/PageMetadata.json';
import { stopReplayOnExcludedRoute } from '../monitoring/replayRouteGate';

function setMeta(attribute: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.content = content;
}

function setCanonical(url: string) {
  let element = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!element) {
    element = document.createElement('link');
    element.rel = 'canonical';
    document.head.appendChild(element);
  }
  element.href = url;
}

function RouteMetadata() {
  const { pathname } = useLocation();

  useEffect(() => {
    stopReplayOnExcludedRoute(pathname);
    const path = pathname.replace(/\/+$/, '') || '/';
    const page = metadata.pages.find((item) => item.path === path);
    if (!page) {
      document.title = 'Page Not Found | Scaled Tech Consulting';
      document.head.querySelector('link[rel="canonical"]')?.remove();
      document.head.querySelector('meta[property="og:url"]')?.remove();
      setMeta('name', 'robots', 'noindex');
      return;
    }

    const url = `${metadata.origin}${page.path}`;
    document.title = page.title;
    document.head.querySelector('meta[name="robots"]')?.remove();
    setCanonical(url);
    setMeta('name', 'description', page.description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:title', page.title);
    setMeta('property', 'og:description', page.description);
    setMeta('name', 'twitter:title', page.title);
    setMeta('name', 'twitter:description', page.description);
  }, [pathname]);

  return null;
}

export default RouteMetadata;
